// @flow
import * as React from 'react'
import DesktopTimeField from './DesktopTimeField'
import MobileNativeTimeField from './MobileNativeTimeField'
import { isMobileBrowser } from '../../utils'

import type { Props as DesktopTimeFieldProps } from './DesktopTimeField'

export type Appearance = 'mobile-native' | 'desktop' | 'mobile'
export type Props = DesktopTimeFieldProps & {
  fieldAppearance?: Appearance,
}

// Constants
const APPEARANCES = {
  'mobile-native': MobileNativeTimeField,
  mobile: MobileNativeTimeField,
  desktop: DesktopTimeField,
}

const TimeField = ({ fieldAppearance, ...props }: Props) => {
  let TimeFieldComponent = null

  if (fieldAppearance) {
    TimeFieldComponent = APPEARANCES[fieldAppearance] || APPEARANCES.desktop
  } else if (isMobileBrowser()) {
    TimeFieldComponent = APPEARANCES['mobile-native']
  } else {
    TimeFieldComponent = APPEARANCES.desktop
  }

  return <TimeFieldComponent {...props} />
}
TimeField.defaultProps = DesktopTimeField.defaultProps

export default TimeField
